// extracted by mini-css-extract-plugin
module.exports = {"adjust":"Loader_adjust__1aQju","loader":"Loader_loader__32j2p","spin":"Loader_spin__2cWnC"};